import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'

interface Stats {
  workers: number
  codes: number
  hotels: number
  activeCodes: number
}

export function Dashboard() {
  const [stats, setStats] = useState<Stats>({ workers: 0, codes: 0, hotels: 0, activeCodes: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchStats()
  }, [])

  async function fetchStats() {
    try {
      const [workers, hotels, codes] = await Promise.all([
        apiFetch('/api/admin/workers'),
        apiFetch('/api/hotels'),
        apiFetch('/api/admin/codes'),
      ])
      setStats({
        workers: workers.workers?.length || 0,
        hotels: hotels.hotels?.length || 0,
        codes: codes.codes?.length || 0,
        activeCodes: codes.codes?.filter((c: any) => !c.used).length || 0,
      })
    } catch {}
    setLoading(false)
  }

  if (loading) return <div className="loading">Loading dashboard...</div>

  return (
    <div className="page">
      <header className="page-header">
        <h1>Dashboard</h1>
        <p>Overview of your DIGSAFE platform</p>
      </header>

      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-icon">👷</span>
          <div className="stat-value">{stats.workers}</div>
          <div className="stat-label">Total Workers</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">🔑</span>
          <div className="stat-value">{stats.activeCodes}</div>
          <div className="stat-label">Active Codes</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">🏨</span>
          <div className="stat-value">{stats.hotels}</div>
          <div className="stat-label">Partner Hotels</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">📋</span>
          <div className="stat-value">{stats.codes}</div>
          <div className="stat-label">Total Codes Used</div>
        </div>
      </div>

      <div className="section">
        <h2>Recent Activity</h2>
        <p className="text-muted">Activity feed coming soon.</p>
      </div>
    </div>
  )
}
